import { EstacaoType } from "../screens/Station";
import { ConectorType } from "../screens/Station";
export const login = async (username: string, password: string) => {
    const body = new FormData();
    body.append('username', username.replaceAll('.', '').replace('-', ''))
    body.append('password', password)

    try {
        const result = await fetch('https://api.eletroposto.gearspark.com.br/api/token/', { method: 'POST', mode: 'cors', body: body })
        if (result.ok) {
            const data = await result.json()
            return data.access
        }
    } catch (error) {
        console.error('Erro:', error)
        throw error;
    }
    return null
}
export const getProfile = async (cpf: string, token: string) => {
    try {
        const result = await fetch(`https://api.eletroposto.gearspark.com.br/api/perfis/?cpf=${cpf}`, { headers: { 'Authorization': `Bearer ${token}` } })
        if (result.ok) {
            const data = await result.json()
            return data[0]
        }
    } catch (error) {
        console.error('Erro:', error)
        throw error;
    }
    return null
}
export const getBalance = async (token: string) => {
    try {
        const result = await fetch('https://api.eletroposto.gearspark.com.br/api/saldo/', { method: 'GET', mode: 'cors', headers: { 'Authorization': `Bearer ${token}` } })
        if (result.ok) {
            const data = await result.json()
            console.log(data)
            const number: number = data.saldo
            return parseFloat(number.toFixed(2))
        }
    } catch (error) {
        console.error('Erro:', error)
        throw error;
    }
    return '--'
}
export const resetPassword = async (cpf: string, celular: string) => {
    try {
        return await fetch(`https://api.eletroposto.gearspark.com.br/api/resetar-senha/${cpf}/`, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json', }, body: JSON.stringify({ celular: celular }), })
    } catch (error) {
        console.error('Erro:', error)
        throw error;
    }
}
export const getEstacoes = async (token: string) => {
    try {
        const result = await fetch(`https://api.eletroposto.gearspark.com.br/api/estacoes/`, { headers: { 'Authorization': `Bearer ${token}` } })
        if (result.ok) {
            const data = await result.json()
            return data
        }
    } catch (error) {
        console.error('Erro:', error)
        throw error;
    }
    return null
}
export const getEntradas = async (token: string) => {
    try {
        const result = await fetch(`https://api.eletroposto.gearspark.com.br/api/entradas/`, { headers: { 'Authorization': `Bearer ${token}` } })
        if (result.ok) {
            const data = await result.json()
            return data
        }
    } catch (error) {
        console.error('Erro:', error)
        throw error;
    }
    return null
}
export const getRecargas = async (token: string) => {
    try {
        const result = await fetch(`https://api.eletroposto.gearspark.com.br/api/recargas/`, { headers: { 'Authorization': `Bearer ${token}` } })
        if (result.ok) {
            const data = await result.json()
            return data
        }
    } catch (error) {
        console.error('Erro:', error)
        throw error;
    }
    return null
}
export const postRecargas = async (token: string, valor: number, conector: ConectorType) => {
    try {
        const result = await fetch(`https://api.eletroposto.gearspark.com.br/api/recargas/`, {
            method: 'POST', mode: 'cors', headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
                energia: 0.0,
                valor: valor,
                conector: conector.id
            })
        })
        if (result.ok) {
            const data = await result.json()
            return data
        } else {
            const data = await result.json()
            return data
            // throw new Error(data.error || 'Erro desconhecido')
        }
    } catch (error) {
        console.error('Erro:', error)
        throw error;
    }
    return null
}
// export const getTokenStation = async (station: EstacaoType) => {
//     try {
//         const result = await fetch(station.token_url, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: station.body_request })
//         return (await result.json()).access_token
//     } catch (error) {
//         console.error('Erro:', error)
//         throw error;
//     }
//     return null
// }

// export const startCharging = async (conector: ConectorType, token: string) => {
//     try {
//         const result = await fetch(conector.start_url, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: conector.body_request })
//         const data = await result.json()
//         return data
//     } catch (error) {
//         console.error('Erro:', error)
//         throw error;
//     }
//     return null
// }